// DTM
import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import LinesEllipsis from "react-lines-ellipsis";
import responsiveHOC from "react-lines-ellipsis/lib/responsiveHOC";
import text from "../helper/text";

const ResponsiveEllipsis = responsiveHOC()(LinesEllipsis);

export const lotShrink = 1170;
export const lotCutOff = 925;
export const lotTrippleState = 800;
export const lotSmallestSize = 650;
export const lotDoubleState = 500;
export const lotSingleState = 310;

const Wrapper = styled.a`
  float: left;
  width: 251px;
  margin: 15px 11px;
  position: relative;
  background-color: white;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);

  @media (max-width: ${lotShrink}px) {
    width: calc(25% - 30px);
  }
  @media (max-width: ${lotCutOff}px) {
    width: calc(33% - 30px);
  }
  @media (max-width: ${lotSmallestSize}px) {
    width: calc(33% - 23px);
    margin: 7px;
  }
  @media (max-width: ${lotDoubleState}px) {
    width: calc(50% - 30px);
  }
  @media (max-width: ${lotSingleState}px) {
    width: calc(100% - 46px);
  }
`;
const Top = styled.div`
  height: 39px;
  width: 100%;
  float: left;
  position: relative;
  @media (max-width: ${lotTrippleState}px) {
    height: 23px;
  }
`;
const LotNo = styled.div`
  position: absolute;
  top: 11px;
  left: 11px;

  height: 17px;
  font-family: Lato;
  font-size: 14px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1px;
  color: #000000;
  text-transform: uppercase;
  @media (max-width: ${lotTrippleState}px) {
    top: 5px;
    left: 8px;

    height: 15px;
    font-size: 12px;
    letter-spacing: 0.8px;
  }
  @media (max-width: ${lotSmallestSize}px) {
    font-size: 10px;
  }
`;
const LotPrice = styled.div`
  position: absolute;
  top: 5px;
  right: 11px;

  height: 19px;
  font-family: Lato;
  font-size: 16px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.1px;
  text-align: right;
  color: #000000;
  @media (max-width: ${lotTrippleState}px) {
    top: 5px;
    right: 8px;

    height: 15px;
    font-size: 12px;
    letter-spacing: 0.8px;
  }
  @media (max-width: ${lotSmallestSize}px) {
    font-size: 10px;
  }
`;
const LotPriceText = styled.div`
  position: absolute;
  top: 24px;
  right: 11px;
  text-transform: uppercase;

  height: 10px;
  font-family: Lato;
  font-size: 8px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.6px;
  text-align: right;
  color: #000000;
  @media (max-width: ${lotTrippleState}px) {
    width: 0;
    height: 0;
    display: none;
    overflow: hidden;
  }
`;
const Middle = styled.div`
  border-top: solid 1px #e5e5e5;
  border-bottom: solid 1px #e5e5e5;
  float: left;
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  background-color: #fcfcfc;
  position: relative;
`;
const Image = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
`;
const Bottom = styled.div`
  float: left;
  margin: 6px 11px 12px 11px;

  width: calc(100% - 22px);
  height: 34px;

  font-family: Lato;
  font-size: 12px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.42;
  letter-spacing: 0.8px;
  color: #000000;

  @media (max-width: ${lotTrippleState}px) {
    margin: 11px 12px 14px 12px;
    width: calc(100% - 24px);

    height: 30px;
    font-size: 11px;
    line-height: 1.36;
  }
  @media (max-width: ${lotSmallestSize}px) {
    margin: 5px 8px 7px 8px;
    width: calc(100% - 16px);

    height: 23px;
    font-size: 10px;
    line-height: 1.25;
    letter-spacing: 0.6px;
  }
`;
const Action = styled.div`
  width: 100%;
  height: 45px;
  float: left;
  background-color: ${props => (props.color ? props.color : "#cfcfcf")};
  position: relative;
  @media (max-width: ${lotSmallestSize}px) {
    height: 28px;
  }
`;
const ActionText = styled.div`
  position: absolute;
  top: 12px;
  width: 100%;
  height: 17px;
  text-transform: uppercase;
  font-family: Lato;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1px;
  text-align: center;
  color: #ffffff;
  @media (max-width: ${lotSmallestSize}px) {
    height: 11px;
    font-size: 10px;
    line-height: 11px;
    letter-spacing: 0.6px;
    top: 9px;
  }
`;

class Lot extends Component {
  getButtonColor = () => {
    if (this.props.content && this.props.content.status) {
      switch (this.props.content.status) {
        case "SOLD":
          return "#cfcfcf";
        case "AFTERSALES":
        case "LIVE_BIDDING":
        case "ONLINE_BIDDING":
          return "#ff5368";
        case "awaiting":
        default:
          return "#3949ab";
      }
    }
    return "#cfcfcf";
  };

  getButtonText = () => {
    if (this.props.content && this.props.content.status) {
      switch (this.props.content.status) {
        case "SOLD":
          return text.get(this.props.translations, "Sold");
        case "AFTERSALES":
          return text.get(this.props.translations, "Buy");
        case "LIVE_BIDDING":
          return text.get(this.props.translations, "Bid_live_now");
        case "ONLINE_BIDDING":
          return text.get(this.props.translations, "Bid_now");
        case "REGISTRATION":
          return text.get(this.props.translations, "View");
        case "awaiting":
        default:
          return "";
      }
    }
    return "";
  };

  render() {
    return (
      <Wrapper
        className="lot"
        href={
          this.props.auctionBaseUrl +
          "/auction_lot/" +
          this.props.content.id +
          "#lot"
        }
      >
        <Top>
          <LotNo>
            {this.props.content && this.props.content.cat
              ? text.get(this.props.translations, "Lot") +
                " " +
                this.props.content.cat
              : ""}
          </LotNo>
          <LotPrice>
            {this.props.content && this.props.content.startingBid
              ? (this.props.content.highestBid &&
                (this.props.content.highestBid.comparedTo(this.props.content.startingBid) >= 0 ||
                this.props.content.status == "SOLD")
                  ? this.props.content.highestBid
                  : this.props.content.startingBid) + "€"
              : ""}
          </LotPrice>
          <LotPriceText>
            {this.props.content && this.props.content.startingBid
              ? this.props.content.highestBid &&
                (this.props.content.highestBid.comparedTo(this.props.content.startingBid) >= 0 ||
                this.props.content.status == "SOLD")
                ? text.get(this.props.translations, "Highest_bid")
                : text.get(this.props.translations, "Starting_bid")
              : ""}
          </LotPriceText>
        </Top>
        <Middle>
          <Image
            style={
              this.props.content && this.props.content.image
                ? {
                    backgroundImage: `url("${this.props.auctionBaseUrl ||
                      "/portal"}/${this.props.content.image}")`
                  }
                : {}
            }
          />
        </Middle>
        <Bottom>
          <ResponsiveEllipsis
            text={this.props.content.description || ""}
            maxLine="2"
          />
        </Bottom>
        <Action color={this.getButtonColor()}>
          <ActionText>{this.getButtonText()}</ActionText>
        </Action>
      </Wrapper>
    );
  }
}

const mapStateToProps = state => {
  return {
    translations: state.translations.data
  };
};

export default connect(mapStateToProps)(Lot);



// WEBPACK FOOTER //
// ./src/components/Lot.js